import { render, staticRenderFns } from "./divider-style.vue?vue&type=template&id=a31136a4&scoped=true&"
import script from "./divider-style.vue?vue&type=script&lang=js&"
export * from "./divider-style.vue?vue&type=script&lang=js&"
import style0 from "./divider-style.vue?vue&type=style&index=0&id=a31136a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a31136a4",
  null
  
)

export default component.exports